'use client'

import dynamic from 'next/dynamic'
import { usePathname } from 'next/navigation'
import { isMarketingPath } from './behmn/routes'
import { ThemeProvider } from './ThemeProvider'
import { CookieConsent } from './tracking/CookieConsent'

// The platform's providers (auth/chat, billing, branding, cart, social, search,
// the AI chat widget and install prompt) are their own chunk. The behmn
// marketing pages use none of them, and loading them there made every page
// download the platform's code and its Supabase client before its photos.
const PlatformProviders = dynamic(() => import('./PlatformProviders').then((m) => m.PlatformProviders))

export function Providers({ children }: { children: React.ReactNode }) {
  if (isMarketingPath(usePathname())) {
    return (
      <ThemeProvider>
        {children}
        <CookieConsent />
      </ThemeProvider>
    )
  }
  return <PlatformProviders>{children}</PlatformProviders>
}
